/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trite_Aqua_Seal_HintInputs */

const en_trite_aqua_seal_hint = /** @type {(inputs: Trite_Aqua_Seal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback`)
};

const de_trite_aqua_seal_hint = /** @type {(inputs: Trite_Aqua_Seal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback`)
};

/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Trite_Aqua_Seal_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const trite_aqua_seal_hint = /** @type {((inputs?: Trite_Aqua_Seal_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trite_Aqua_Seal_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trite_aqua_seal_hint(inputs)
	return de_trite_aqua_seal_hint(inputs)
});